import React from 'react';

class StringUtils {
    static IMG_REGEX = /{img=([a-zA-Z0-9;:,./ =\n+]+)}/g;

    static parse(input) {
        const imgs = [];
        const matches = input.match(this.IMG_REGEX) || [];
        for (const match of matches) {
            const src = match.slice(5, -1);
            imgs.push(<img alt="external" className="external-image" src={src} />);
        }
        let imgIndex = 0;
        return input
            .split(this.IMG_REGEX)
            .map((item, index, array) => {
                const key = "text-segment-" + index;
                if (index < array.length - 1 && index % 2 === 0) {
                    const image = imgs[imgIndex];
                    imgIndex += 1;
                    return (<span key={key}>{item}{image}</span>);
                } else if (index === array.length - 1) {
                    return (<span key={key}>{item}</span>);
                }
                return (<span key={key} />);
            });
    }

    static getLastImage(question) {
        if (question == null) return null;
        return question
            .split(StringUtils.IMG_REGEX)
            .reduce((prev, current, index) => {
                if (index % 2 === 1) return current;
                else return prev;
            }, null);
    }

    static removeImage(question) {
        if (question == null) return null;
        return question.replace(this.IMG_REGEX, '');
    }

    static createTextWithImg(text, img) {
        if (img != null) {
            return `${text} {img=${img}}`;
        } else {
            return text;
        }
    }

    static isBlank(str) {
        return (!str || /^\s*$/.test(str));
    }

    static toSafeString(str) {
        return str.replace(/[^a-zA-Z\d-']/g, '').toLowerCase();
    }
}

export default StringUtils;